export const SUBSCRIPTIONS_PAYMENT_SYSTEMS = {
    STRIPE: 'stripe',
    INVOICE: 'invoice',
    WAYFORPAY: 'wayforpay',
}
